import Model from 'src/app/common/model';
import CustomerPondModel from './customerPond.model';
import FarmSiteModel from './farmSite.model';

export default class PondSectionModel extends Model {
  FarmSiteDetails: Array<FarmSiteModel>;
  section_name: string;
  start_date?: Date;
  end_date?: Date;
  person_id?: string;
  farm_site_id?: string;
  isAssigned?: boolean;
  Ponds: IPonds;
  personID?: string;
  ids?: Array<string>;

  constructor() {
    super();
  }
}

//////////////////////////////
//IPonds
//////////////////////////////
export class IPonds {
  activePonds: Array<CustomerPondModel>;
  inActivePonds: Array<CustomerPondModel>;
  preparatoryPonds: Array<CustomerPondModel>;

 constructor() {
    this.activePonds = new Array();
    this.inActivePonds = new Array();
    this.preparatoryPonds = new Array();
  }
}
